<template>
	<div>
		<accordion v-if="!noAccordion">

			<template slot="heading">
				<div class="row align-items-baseline w-100">

					<div class="col-sm-5">{{checklistName}}</div>

					<div class="col-sm-5 font-weight-normal" style="font-size: 16px">
						<span v-if="checklist.category_id > 0">
							from service category
							<span v-if="'Category' in checklist && checklist.Category && 'name' in checklist.Category && checklist.Category.name">
								"{{checklist.Category.name}}"
							</span>
						</span>
						<span v-else-if="checklist.customer_asset_id > 0">
							from worksheet asset
							<span v-if="'CustomerAsset' in checklist && checklist.CustomerAsset && 'description' in checklist.CustomerAsset && checklist.CustomerAsset.description">
								"{{checklist.CustomerAsset.description}}"
							</span>
						</span>
					</div>

					<div class="col-sm-2 text-right">
						<span v-if="numCompleted == numTotal">COMPLETED</span>
						<span v-else>{{numCompleted}} / {{numTotal}}</span>
					</div>
				</div>
			</template>

			<div class="border rounded px-4 py-3 mb-4">
				<field
					v-for="(item,index) in mutatedChecklistItems"
					:params="{type:'boolean',checkbox:true,text:item.text}"
					:readonly="readonly"
					v-model="item.value"
					v-on:change="itemChanged($event, item, index)">
				</field>

				<div class="d-flex justify-content-end">
					<button v-if="hasModulePermWrite('JobChecklist')" type="button" class="btn btn-outline-danger mr-3" v-on:click="confirmDeleteModalVisible = true">
						<i class="fa fa-trash"></i>
						Delete Checklist
					</button>

					<button type="button" class="btn btn-primary" v-on:click="saveChecklist">
						<i class="fa fa-save"></i>
						Save
					</button>
				</div>
			</div>
		</accordion>

		<field
			v-else
			v-for="item in mutatedChecklistItems"
			:params="{type:'boolean',checkbox:true,text:item.text}"
			:readonly="readonly"
			v-model="item.value"
			v-on:change="itemChanged($event, item)">
		</field>

		<modal-dialog
			:modal-visible="confirmDeleteModalVisible"
			title="Confirm Delete"
			confirm-button-text="Delete"
			button-class="btn-outline-danger"
			v-on:confirm="deleteChecklist"
			v-on:closeModal="confirmDeleteModalVisible = false">

			Are you sure you want to delete this service checklist?

		</modal-dialog>

		<modal-dialog
			:modal-visible="confirmUncheckModal.visible"
			title="Mark as Incomplete?"
			confirm-button-text="Proceed"
			button-class="btn-outline-primary"
			v-on:confirm="confirmUncheck"
			v-on:closeModal="cancelUncheck">

			Are you sure you want to mark this item as incomplete?

		</modal-dialog>
	</div>
</template>

<script type="text/javascript">


import Accordion from "@/components/Accordion"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

export default {
	name: "ChecklistFillable",
	components: {
		Accordion,
		Field,
		ModalDialog
	},
	props: [
		"checklist",
		"noAccordion",
		"readonly"
	],
	data() {
		return {
			localChecklist: null,
			localChecklistItems: [],
			confirmDeleteModalVisible: false,
			confirmUncheckModal: {
				visible: false,
				itemIndex: null
			}
		}
	},
	watch: {
		checklist() {
			this.setLocalChecklist()
		}
	},
	computed: {
		numTotal() {
			return this.localChecklistItems.filter(item => 'optional' in item && item.optional != 1).length
		},
		numCompleted() {
			return this.localChecklistItems.filter(item => {
				return ('value' in item && item.value == 1) && !('optional' in item && item.optional == 1)
			}).length
		},
		checklistName() {
			return (this.localChecklist && 'name' in this.localChecklist && this.localChecklist.name) ?
				this.localChecklist.name : ""
		},
		mutatedChecklistItems() {
			return this.localChecklistItems.map(item => {
				item.text = item.description

				console.log(item)

				let completedAtLocal = this.formatDateTimeToLocal(item.completedAt)

				if ('optional' in item && item.optional == 1)
					item.text += "<span class='text-danger'>&emsp;(Optional)</span>"

				if ('value' in item && item.value == 1 && 'completedBy' in item && item.completedBy)
					item.text += "<span class='font-italic'>&emsp;(Marked complete by " + item.completedBy + " on " + completedAtLocal + ")</span>"

				return item
			})
		}
	},
	methods: {
		deleteChecklist() {
			const vm = this

			vm.confirmDeleteModalVisible = false

			this.postData("JobChecklist/delete", { id: this.localChecklist.id }).then(response => {
				if (response.success) {
					vm.$emit('deleted', this.localChecklist)
				}
			})
		},
		saveChecklist() {
			const vm = this

			let payload = this.cloneObj(this.localChecklist)

			let items = this.cloneObj(this.localChecklistItems)
			items.forEach(item => {
				if ('text' in item)
					delete item.text
			})


			try {
				payload.items_json = JSON.stringify(items)
			} catch {
				this.alertFail("Unable to save checklist.")
				return
			}

			this.postData("JobChecklist/save", payload).then(response => {
				if (response.success)
					vm.$emit('saved', payload)
			})
		},
		itemChanged(value, item, index) {
			if (!value) {
				this.confirmUncheckModal.visible = true
				this.confirmUncheckModal.itemIndex = index
			}
			else {
				item.completedBy = this.buildName(this.$store.userDetails)
				item.completedAt = this.moment().utc().format('YYYY-MM-DD HH:mm:ss')   // store datetime as UTC
			}
		},
		confirmUncheck() {
			let item = this.mutatedChecklistItems[this.confirmUncheckModal.itemIndex]

			if ('completedBy' in item)
				delete item.completedBy
			if ('completedAt' in item)
				delete item.completedAt

			this.confirmUncheckModal.visible = false
		},
		cancelUncheck() {
			this.mutatedChecklistItems[this.confirmUncheckModal.itemIndex].value = true
			this.confirmUncheckModal.visible = false
		},
		setLocalChecklist() {
			if (this.checklist) {
				this.localChecklist = this.cloneObj(this.checklist)
				this.localChecklistItems = []

				if ('items_json' in this.checklist && this.checklist.items_json) {
					try {
						this.localChecklistItems = JSON.parse(this.checklist.items_json)
					} catch {}
				}
			}
		}
	},
	mounted() {
		this.setLocalChecklist()
	}
}

</script>